import React from 'react'
import { Table as BsTable } from 'react-bootstrap'
import { Link } from 'react-router'
import Icon from './icon'
import icons from '_/config/icons.json'
import dateToTimeString from '_/utils/dateToTimeString'
import getDisplayName from '_/utils/getDisplayName'
import Pagination from './pagination'
import getGravatarUrl from '_/utils/getGravatarUrl'

/**
 * Data table component
 */
class Table extends React.Component {
  static propTypes = {
    list: React.PropTypes.object.isRequired,
    route: React.PropTypes.string,
    tools: React.PropTypes.array,
    columns: React.PropTypes.array.isRequired,
    isPlain: React.PropTypes.bool,
    search: React.PropTypes.string,
    offset: React.PropTypes.number,
    sort: React.PropTypes.string,
    dir: React.PropTypes.string,
    limit: React.PropTypes.number
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  _toggleSort (nextSort) {
    if (this.props.isPlain) return null
    let nextDir = 'asc'

    if (this.props.sort === nextSort) {
      nextDir = this.props.dir === 'asc' ? 'desc' : 'asc'
    }

    this.context.router.transitionTo(this.props.route, null, {
      search: this.props.search,
      sort: nextSort,
      dir: nextDir
    })
  }

  _renderSortIcon (col) {
    if (col.name !== this.props.sort) return null

    return (
      <div className="pull-right">
        <Icon name={`fa-chevron-circle-${this.props.dir === 'asc' ? 'up' : 'down'}`} />
      </div>
    )
  }

  _renderHeaderRow() {
    const { columns, tools } = this.props
    const toolHeader = tools && <th width={25 * tools.length} />

    return (
      <tr>
        {toolHeader}
        {columns.map( (col, i) => (
          <th className={col.sortable && 'sortable'}
            key={i}
            width={col.width}
            onClick={col.sortable && this._toggleSort.bind(this, col.name)}>
            {col.sortable && this._renderSortIcon(col)}
            {col.label}
          </th>
        ))}
      </tr>
    )
  }

  _formatData (col, record) {
    /* eslint complexity:0 */
    const value = Array.isArray(col.name)
      ? record.getIn(col.name)
      : record.get(col.name)

    let formatted = value

    if (col.custom) formatted = col.custom(record)

    switch (col.format) {
      case 'array':
        formatted = value.join(', ')
        break
      case 'bool':
        formatted = value === true ? 'Yes' : 'No'
        break
      case 'date':
        formatted = dateToTimeString(new Date(value))
        break
      case 'address':
        formatted = getDisplayName('property', record)
        break
      case 'gravatar':
        formatted = <img src={getGravatarUrl(value, 40)} style={{width: 20}} />
        break
      case 'icon':
        formatted = <Icon name={icons[value]} />
        break
      case 'email':
        formatted = <a href={`mailto:${value}`}>{value}</a>
        break
      case 'eval':
        formatted = <div dangerouslySetInnerHTML={{ __html: value }} />
        break
      case 'photo':
        formatted = <p className="text-center"><img src={`/api/v1/properties/${value}.jpg`} style={{maxHeight: 60, maxWidth: col.width - 20}} /></p>
        break

      default:
    }

    if (col.viewRoute) {
      return (
        <Link className="hotkeys-select" to={col.viewRoute} params={{id: record.get('id')}}>
          {formatted}
        </Link>
      )
    }

    return formatted
  }

  _renderRecordRow (record, idx) {
    const { columns, tools } = this.props
    const toolRow = tools && <td>{tools.map((tool, key) => <span key={key}>{tool}&nbsp;</span>)}</td>

    return (
      <tr key={idx}>
        {toolRow}
        {columns.map( (col, i) => (
          <td key={i} data-label={col.label}>{this._formatData(col, record)}</td>
        ))}
      </tr>
    )
  }

  render() {
    const records = this.props.list.get('data')

    return (
      <div>
        <BsTable bordered hover className="redi-component-table">
          <thead>
            {this._renderHeaderRow()}
          </thead>
          <tbody>
            {records.map(this._renderRecordRow.bind(this))}
          </tbody>
        </BsTable>
        <Pagination {...this.props} />
      </div>
    )
  }
}

export default Table



// WEBPACK FOOTER //
// ./modules/shared/components/table.js